'use strict';

var _ = require('lodash');
var SnapshotDatesMapDataToChartComponentsService = function SnapshotDatesMapDataToChartComponentsService() {
  var mapPropertiesToChartComponents = {
    group: 'runNumber',
    m1Bar: 'm1',
    circles: 'circles',
    scaleMetric: 'm1',
    yRightLabel: 'Average Effective Fare Change',
    secondaryScaleMetric: 'effectedServices',
    complementarySecondaryScaleMetric: 'excludedServices',
    yLeftLabel: 'Services',
    metricTooltipLabel: 'Avg Eff Fare Change'
  };
  function getMapComponent(key) {
    return _.get(mapPropertiesToChartComponents, key);
  }
  function setMapComponent(key, value) {
    _.set(mapPropertiesToChartComponents, key, value);
  }
  return {
    getMapComponent: getMapComponent,
    setMapComponent: setMapComponent
  };
};
SnapshotDatesMapDataToChartComponentsService.$inject = [];
module.exports = SnapshotDatesMapDataToChartComponentsService;